import {Repository} from "./Repository";
import {AxiosInstance} from "axios";
import {NotificationUpdates} from "../models/notifications/NotificationUpdates";

export class NotificationRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    updates(lastUpdatedAt = '') {
        return this.client.get<NotificationUpdates>(`/notifications/updates`, {
            params: {
                lastUpdatedAt
            }
        })
            .then(({data}) => {
                return new NotificationUpdates(data);
            })
    }

    markAsRead(lastUpdatedAt: string, deepLink: string) {
        let url = `/notifications/markAsRead?lastUpdatedAt=` + encodeURIComponent(lastUpdatedAt);
        if (deepLink.length) {
            url = `/notifications/markAsRead?deepLink=` + encodeURIComponent(deepLink);
        }
        return this.client.put<number>(url).then(({data}) => data);
    }

    markAsReadByDeepLink(deepLink: string) {
        let url = `/notifications/markAsRead?deepLink=` + encodeURIComponent(deepLink);
        return this.client.put<number>(url).then(({data}) => data);
    }

    markAsReadById(id: string) {
        let url = `/notifications/markAsRead?id=` + encodeURIComponent(id);
        return this.client.put<number>(url).then(({data}) => data);
    }

    count() {
        return this.client.get<number>(`/notifications/count`).then(({data}) => data);
    }
}